import { render, staticRenderFns } from "./PreOrderRedirect.vue?vue&type=template&id=677bb379&scoped=true"
import script from "./PreOrderRedirect.vue?vue&type=script&lang=js"
export * from "./PreOrderRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677bb379",
  null
  
)

export default component.exports